export default __webpack_public_path__ + "static/media/phase1.9bc05f40.png";